import { useEffect, useState } from 'react';
import bookingService from '../services/BookingService';
import { sortSlots } from '../utils/helpers/sortSlots';

export const useDatesLocationV3Slots = (locationServicePairs, selectedDates, displayedItemCodes, showDailyFilters) => {
  const [dateSlotsPerLocation, setdateSlotsPerLocation] = useState({});
  const [error, setError] = useState(null);
  if (!showDailyFilters) return;
  const dates = selectedDates.map(date => date.apiFormat);

  useEffect(() => {
    async function fetchAllTimeSlots() {
      setError(null);
      try {
        const response = await bookingService.getDatesLocationV3Slots(locationServicePairs, dates);
        if (!response.error) sortSlots(response, setdateSlotsPerLocation);
        else setError(response.error);
      } catch (err) {
        setError(err.message);
      }
    }
    if (locationServicePairs.length > 0 && dates && dates.length !== 0) fetchAllTimeSlots();
  }, [locationServicePairs, selectedDates, displayedItemCodes]);

  return { dateSlotsPerLocation, error };
};
